module.exports = __webpack_public_path__ + "static/media/icon_amazon.97ae92da.png";